module.exports = __webpack_public_path__ + "img/banniere_6.badc8a9c.jpg";